import React from 'react';
import {CommonShow} from '../Common';
import {getFields} from './Common';

export const ContractIndexValueShow = props => (
  <CommonShow
    {...{
      ...props,
      fields: getFields(),
    }}
  />
);
